define.alias("ember-truth-helpers/helpers/is-equal", "preview-grid/helpers/is-equal");